import React from 'react';
import {useSelector, useDispatch} from "react-redux";
import {get} from 'lodash';
import classNames from 'classnames';

import {FILTER_1} from "../../../../../reducers/performance_reducers";
import {
    SetDashboardFiltersAction,
    CleanDashboardDataAction
} from "../../../../../actions/performance_actions";

export default function () {
    const dispatch = useDispatch();

    const dashboard_filters = useSelector(state => state.dashboard_filters);
    const dashboard_teacher_filter = useSelector(state => state.dashboard_teacher_filter);

    const filters = dashboard_filters[FILTER_1];

    if (!dashboard_teacher_filter) {
        return null;
    }

    const selected_teacher_id = get(filters.teacher_id, 0);

    const onClick = (teacher_id) => () => {
        if (teacher_id == selected_teacher_id) {
            return;
        }
        const dashboard_filters_copy = JSON.parse(JSON.stringify(dashboard_filters));
        if (teacher_id) {
            dashboard_filters_copy[FILTER_1]['teacher_id'] = [teacher_id];
        } else {
            dashboard_filters_copy[FILTER_1]['teacher_id'] = [];
        }
        dispatch(CleanDashboardDataAction());
        dispatch(SetDashboardFiltersAction(dashboard_filters_copy));
    }

    const render_teachers = dashboard_teacher_filter.map((teacher) => {
        const class_names = classNames("pam-selection-one-item flex-row flex-gap-10", {
            "pam-selection-one-item-selected": teacher.teacher_id == selected_teacher_id
        });
        return (
            <div key={teacher.teacher_id} className={class_names} onClick={onClick(teacher.teacher_id)}>
                <div>
                    {`${teacher.teacher_name}`}
                </div>
            </div>
        );
    });

    const class_names_all = classNames("pam-selection-one-item", {
        "pam-selection-one-item-selected": selected_teacher_id == undefined
    });

    return (
        <div className="flex-auto pam-selection-scroll">
            <div className="flex-column flex-gap-5">
                <div className={class_names_all} onClick={onClick(undefined)}>
                    {`All Teachers`}
                </div>

                {render_teachers}
            </div>
        </div>
    );
}
